import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { ServiceConstant } from '../utils/service-constant.util';
import { FNFResponse } from '../models/response';
import { RestaurantQrCodes, SetQrCodes } from '../models/qr-codes';

/**
 * The restaurant's QR sheet (restaurant-service PR #418, Kong PR #98).
 *
 * Unlike the older services these calls throw on failure instead of swallowing
 * the error, so the page can show a real error state (dev 404s until both PRs
 * land) rather than mistaking a failed load for a restaurant without codes.
 */
@Injectable({
  providedIn: 'root',
})
export class QrCodesService {
  private httpClient = inject(HttpClient);
  private readonly url = ServiceConstant.apiUrl + '/restaurants/qr-codes';

  /** Every code of the restaurant: To-Go counter, To-Go dining tables, dine-in tables. */
  getQrCodes(): Observable<RestaurantQrCodes> {
    return this.httpClient
      .get<FNFResponse<RestaurantQrCodes>>(this.url)
      .pipe(map((res) => this.dataOrThrow(res)));
  }

  /** Sets Table 1..n for To-Go dining and returns the whole sheet again. */
  setTogoTableCount(togoTableCount: number): Observable<RestaurantQrCodes> {
    const body: SetQrCodes = { togo_table_count: togoTableCount };
    return this.httpClient
      .put<FNFResponse<RestaurantQrCodes>>(this.url, body)
      .pipe(map((res) => this.dataOrThrow(res)));
  }

  private dataOrThrow(res: FNFResponse<RestaurantQrCodes> | null): RestaurantQrCodes {
    if (!res?.data) {
      throw new Error(res?.error?.message || res?.message || 'The QR codes could not be loaded.');
    }
    return res.data;
  }
}
